import { trimBasenameAndNetworkFromUrlPath } from './trimBasenameFromUrlPath';
import { trimLeadingAndTrailingSlash } from './trimSlash';
import { getUrlRootPath } from './urlRootPath';

export type GetEventBroadcastIdFromPath = (urlPath: string) => string | undefined;
export const getEventBroadcastIdFromPath: GetEventBroadcastIdFromPath = (urlPath) => {
  const urlPathWithoutBasename = trimBasenameAndNetworkFromUrlPath(urlPath);
  const urlPathParts = trimLeadingAndTrailingSlash(urlPathWithoutBasename).split('/');

  if (urlPathParts[0] === 'events' && urlPathParts[1] && urlPathParts[1] !== 'new') {
    return urlPathParts[1];
  }

  return undefined;
};

export type IsEventsPage = (urlPath: string) => boolean;
export const isEventsPage = (urlPath: string): boolean => {
  const urlRootPath = getUrlRootPath(urlPath);

  return urlRootPath === 'events';
};
